import { ISkuInput } from "@/interfaces/sku.interface";
import {
  filterRemovedVariations,
  getDefaultVariationName,
  parseVariationsFromString,
  stringifyVariations,
} from "@/helpers/variation-helpers";

interface VariationUpdateParams {
  value: string[];
  currentVariationCodes: string[];
  skus: ISkuInput[];
  variationItems: Array<{ id: number; description: string }>;
}

export const buildUpdatedVariations = (
  selectedCodes: string[],
  variationItems: Array<{ id: number; description: string }>
) => {
  return selectedCodes.map((variationCode) => {
    const variationItem = variationItems.find((item) => item.id === Number(variationCode));

    return {
      code: Number(variationCode),
      name: variationItem
        ? variationItem.description
        : getDefaultVariationName(Number(variationCode)),
    };
  });
};

export const getRemovedVariationCodes = (currentCodes: string[], newCodes: string[]): string[] => {
  return currentCodes.filter((code) => !newCodes.includes(code));
};

export const updateSkusWithRemovedVariations = (
  skus: ISkuInput[],
  removedVariationCodes: string[]
): ISkuInput[] => {
  return skus.map((sku) => {
    if (!sku.variations || typeof sku.variations !== "string" || sku.variations.trim() === "") {
      return sku;
    }

    const skuVariations = parseVariationsFromString(sku.variations);
    const filteredVariations = filterRemovedVariations(skuVariations, removedVariationCodes);

    return {
      ...sku,
      variations: stringifyVariations(filteredVariations),
    };
  });
};

export const shouldUpdateSkus = (removedVariationCodes: string[], skus: ISkuInput[]): boolean => {
  return removedVariationCodes.length > 0 && skus.length > 0;
};
